export const CUSTOM_STYLES_ELEMENT_ID = 'chekin-sdk-custom-styles';
export const CUSTOM_STYLES_LINK_ELEMENT_ID = 'chekin-sdk-custom-styles-link';
